export default __webpack_public_path__ + "static/media/forgot_pass_bg.9cfc5f78.png";